// extracted by mini-css-extract-plugin
export var boggs_modal_container = "layout-module--boggs_modal_container--Y3SFv";
export var fadeInOut = "layout-module--fadeInOut--8UfqO";
export var loader = "layout-module--loader--AnDUB";
export var loader_container = "layout-module--loader_container--K8oXt";
export var square = "layout-module--square--oCNLt";
export var text = "layout-module--text--wwTip";
export var translateSquares = "layout-module--translateSquares--qo+Fa";